import * as React from "react";
const SvgChevronDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      stroke="currentColor"
      d="M16 22.033 2.441 8.405 1 9.923l15 14.868L31.062 9.923l-1.43-1.518z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChevronDown;
